export const getClosedRemoveBackgroundDialog = () => ({
	open: false,
	backgroundId: null,
	affectedWidgetIds: [],
	affectedCount: 0,
});

export const rectanglesOverlap = (first, second) => (
	first.left < second.right &&
	first.right > second.left &&
	first.top < second.bottom &&
	first.bottom > second.top
);

export const getWidgetsOverlappingBackground = ({
	backgroundWidget,
	widgetsToCheck = [],
	metrics,
	getWidgetRectPx,
}) => {
	if (!backgroundWidget || !Array.isArray(widgetsToCheck)) return [];

	const backgroundRectPx = getWidgetRectPx(backgroundWidget, metrics);
	const bgRect = {
		left: backgroundRectPx.left,
		top: backgroundRectPx.top,
		right: backgroundRectPx.left + backgroundRectPx.width,
		bottom: backgroundRectPx.top + backgroundRectPx.height,
	};

	return widgetsToCheck.filter((widget) => {
		if (!widget || widget.id === backgroundWidget.id) return false;
		if (widget.type === 'background-image' || widget.type === 'box-widget') return false;

		const widgetRectPx = getWidgetRectPx(widget, metrics);
		const widgetRect = {
			left: widgetRectPx.left,
			top: widgetRectPx.top,
			right: widgetRectPx.left + widgetRectPx.width,
			bottom: widgetRectPx.top + widgetRectPx.height,
		};

		return rectanglesOverlap(bgRect, widgetRect);
	});
};

export const getBackgroundRemovalWidgetGroups = ({
	widgets = [],
	backgroundId,
	affectedWidgetIds = [],
	metrics,
	getWidgetRectPx,
}) => {
	const widgetsWithoutBackground = widgets.filter((widget) => widget.id !== backgroundId);
	const affectedSet = new Set(affectedWidgetIds);
	const affectedWidgets = widgetsWithoutBackground.filter((widget) => affectedSet.has(widget.id));
	const stationaryWidgets = widgetsWithoutBackground.filter((widget) => !affectedSet.has(widget.id));
	const sortedAffectedWidgets = [...affectedWidgets].sort((a, b) => {
		const rectA = getWidgetRectPx(a, metrics);
		const rectB = getWidgetRectPx(b, metrics);
		const areaA = rectA.width * rectA.height;
		const areaB = rectB.width * rectB.height;
		return areaB - areaA;
	});

	return {
		widgetsWithoutBackground,
		stationaryWidgets,
		sortedAffectedWidgets,
	};
};

export const getRemoveBackgroundDialogState = ({
	backgroundId,
	overlappingWidgets,
}) => ({
	open: true,
	backgroundId,
	affectedWidgetIds: overlappingWidgets.map((widget) => widget.id),
	affectedCount: overlappingWidgets.length,
});
